import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import { stockOutSendType } from "src/api/commonapi";
import { notification } from "src/utils/messages";

export default function SendTypeInsertUpdateModal({
  addEditModal,
  setAddEditModal,
  toggleAddEditModal,
  modalType,
  rowData,
  handleGetSendType
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [loader, setLoader] = useState(false);
  const [sendTypeData, setSendTypeData] = useState({
    type_name: modalType === "Edit" ? rowData?.type_name : "",
    method: modalType === "Edit" ? 2 : 1
  });
  const [isLoading, setIsLoading] = useState(false);

  const resetFormData = () => {
    setSendTypeData({
      type_name: "",
      method: modalType === "Edit" ? 2 : 1
    });
  };

  const handleStockOutSendTypeSubmit = async () => {
    if (sendTypeData.type_name != "" && sendTypeData.method != "") {
      if (modalType === "Edit") {
        setLoader(true);
        setIsLoading(true);
        let resp = await stockOutSendType({ ...sendTypeData, s_type_id: rowData.s_type_id });
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetSendType();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoader(false);
      } else {
        setLoader(true);
        setIsLoading(true);
        let resp = await stockOutSendType(sendTypeData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetSendType();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoader(false);
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} New Send Type
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginTop: "15px" }}
                height={10}
                fullWidth
                multiline
                autoComplete="off"
                type="text"
                label="Type Name"
                name="type_name"
                placeholder="Enter Type Name"
                onChange={(e) => {
                  setSendTypeData({
                    ...sendTypeData,
                    type_name: e.target.value
                  });
                }}
                value={sendTypeData?.type_name}
              />
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAddEditModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleStockOutSendTypeSubmit()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
